import { routes } from "@/apps/dashboard/organization/routing/routes";
import * as userConstants from "@/core/models/usersAndPermissions";

const router = [
  {
    ...routes.linkedBuyers,
    component: () =>
      import(
        /* webpackChunkName: "db-link-retailer-buyer" */ "@/apps/dashboard/organization/view/pages/LinkedBuyers/LinkedBuyers.vue"
      ),
    props: true,
  },
  {
    ...routes.betaAccountEdit,
    component: () =>
      import(
        /* webpackChunkName: "db-account-client" */ "@/apps/dashboard/organization/view/pages/Account/Account.vue"
      ),
    props: (route: any) => ({
      accountId: route.params.accountId,
    }),
    meta: {
      permission: userConstants.ROLE_CLIENT_UPDATE_PAGE,
    },
  },
];

export default router;
